import { apiService } from './apiService';
import { API_BASE_URL } from '../config/env';

const API_URL = API_BASE_URL + '/token/';
const REFRESH_URL = API_BASE_URL + '/token/refresh/';

export interface UserClinic {
  id: number;
  name: string;
}

export interface AssignedProfessional {
  id: number;
  name: string;
  email: string;
  role: string;
}

export interface User {
  id: number;
  username: string;
  email: string;
  firstName: string;
  lastName: string;
  role: string;
  clinic?: UserClinic | null;
  assignedProfessional?: AssignedProfessional | null;
}

export const authService = {
  login: async (email: string, password: string) => {
    // A 401 here means the credentials were rejected, not that a session
    // expired, so it has to reach the form instead of triggering the global
    // redirect. Refresh below keeps the default: if the refresh token is
    // refused the session really is over.
    const data = await apiService.post(
      API_URL,
      { username: email, password },
      { redirectOn401: false },
    );
    return {
      access: data.access,
      refresh: data.refresh,
      user: data.user,
    };
  },

  // Exchange the refresh token for a fresh access token (SimpleJWT TokenRefreshView).
  refresh: async (refreshToken: string): Promise<{ access: string }> => {
    const data = await apiService.post(REFRESH_URL, { refresh: refreshToken });
    return { access: data.access };
  },
}; 